import {
	ApiUtils,
	_axios
}from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
	list: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/stu/stu/list", params, successCallback, failCallback, exceptionCallback);
	},isTrCanPJ: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/stu/stu/isTrCanPJ", params, successCallback, failCallback, exceptionCallback);
	},kfp: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/stu/stu/kfp", params, successCallback, failCallback, exceptionCallback);
	},save: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/stu/stu/save", params, successCallback, failCallback, exceptionCallback);
	},expstus: (params,fname) => {
        ApiUtils.downloadingAjax(constant.serverUrl+"/stu/stu/expExcel?ids="+params+"&fn="+fname,"", fname, "excel");
    },jspj: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/stu/stu/jspj", params, successCallback, failCallback, exceptionCallback);
	},jisou: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/stu/stu/jisou", params, successCallback, failCallback, exceptionCallback);
	},genJW: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/stu/stu/genJW", params, successCallback, failCallback, exceptionCallback);
	},toUpdate: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/stu/stu/toUpdate", params, successCallback, failCallback, exceptionCallback);
	},update: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/stu/stu/update", params, successCallback, failCallback, exceptionCallback);
	},remove: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/stu/stu/remove", params, successCallback, failCallback, exceptionCallback);
	},getOne:(params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/stu/stu/getOne", params, successCallback, failCallback, exceptionCallback);
	}
}       

export default api;
